const AUTH_LOGOUT_EVENT = 'scraplands:auth-logout';

export const authEvents = {
    emitLogout(reason = 'logout') {
        window.dispatchEvent(new CustomEvent(AUTH_LOGOUT_EVENT, {detail: {reason}}));
    },

    onLogout(handler) {
        const listener = (event) => handler(event.detail || {});
        window.addEventListener(AUTH_LOGOUT_EVENT, listener);
        return () => window.removeEventListener(AUTH_LOGOUT_EVENT, listener);
    },
};
